<template>
    <div class="container relative mx-auto mb-40 mt-24 max-w-[1200px] text-center">
        <h2 class="mb-10 whitespace-pre-line text-2xl font-bold leading-relaxed md:mb-[72px] lg:text-4xl">{{ source.title }}</h2>
        <div class="container mx-auto flex flex-col">
            <div class="items order-2 mb-9 grid grid-cols-1 gap-16 max-lg:pt-6 md:mb-0 md:grid-cols-2 md:gap-20 lg:order-1">
                <div v-for="(item, index) in source.items" :key="index" class="item flex px-4 max-md:space-x-3">
                    <img class="left mr-2 h-12 w-12 md:mr-6 md:h-[70px] md:w-[70px]" :src="`${ossPath}${item.img.src}`" :alt="item.img.alt" />
                    <div class="right text-left">
                        <h5 class="text-lg font-bold md:text-[22px] lg:mb-5">{{ item.title }}</h5>
                        <p class="whitespace-pre pt-1 text-base font-medium md:text-lg">{{ item.desc }}</p>
                    </div>
                </div>
            </div>
            <div class="blocks order-1 grid grid-cols-2 px-[10px] lg:order-2 lg:flex lg:space-x-4 lg:pb-20 lg:pt-28">
                <div class="border-box flex flex-1 items-center justify-center rounded-[20px] py-[20px]">
                    <div class="leftbox mx-auto flex h-full w-[98%] justify-center pb-[40px] pt-[30px] lg:w-[580px]">
                        <div class="w-full lg:w-[419.66px]">
                            <h3 class="pb-[15px] text-center text-[26px] font-bold max-sm:text-lg lg:text-left">{{ source.blocks[0].title }}</h3>
                            <div class="w-full">
                                <img class="h-[150px] object-contain lg:h-[264px]" :src="`${ossPath}${source.blocks[0].img}`" alt="" />
                            </div>
                            <div class="items-center justify-center px-[10px] pb-9 pt-6 lg:flex lg:px-0">
                                <span class="pr-[5px] text-lg font-bold text-[#333] md:text-[24px]"> {{ source.blocks[0].discount }} </span>
                            </div>
                            <ul class="space-y-5 px-[10px] text-left lg:px-0">
                                <li v-for="(innerItem, i) in source.blocks[0].content" :key="i" class="flex items-start gap-2 max-sm:text-sm sm:gap-4">
                                    <img :src="`${ossPath}/shop/s55/勾选_2 1.png`" alt="" class="h-5 w-5 sm:h-6 sm:w-6" />
                                    {{ innerItem }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="border-box flex flex-1 scale-95 items-center justify-center rounded-[20px] py-[20px]">
                    <div class="rightbox mx-auto flex h-full w-[98%] justify-center overflow-hidden pb-[40px] pt-[30px]">
                        <div class="w-[100%] lg:w-[419.66px]">
                            <h3 class="pb-[15px] text-center text-[26px] font-bold max-sm:text-lg lg:text-left">{{ source.blocks[1].title }}</h3>
                            <div>
                                <img class="h-[150px] object-contain lg:h-[264px]" :src="`${ossPath}${source.blocks[1].img}`" alt="" />
                            </div>
                            <div class="flex flex-col items-center justify-center pb-9 pt-3 max-lg:mb-8 lg:px-0">
                                <span class="text-lg font-bold text-[#333] md:text-[24px]"> {{ source.blocks[1].price }} </span>
                                <div class="w-[60%] pt-2 text-sm"><i class="text-[red]">* </i>{{ source.blocks[1].desc }}</div>
                            </div>
                            <ul class="space-y-5 px-[10px] text-left lg:px-0">
                                <li v-for="(innerItem, i) in source.blocks[1].content" :key="i" class="flex gap-2 max-sm:text-sm sm:gap-4"><img :src="`${ossPath}/shop/s55/cha.png`" alt="" class="h-5 w-5 sm:h-6 sm:w-6" /> {{ innerItem }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="absolute -bottom-16 order-3 flex w-full items-end justify-center">
                <button class="dasiy-btn dasiy-btn-lg h-fit cursor-pointer rounded-full !px-12 py-4 font-semibold text-white opacity-100" @click="showDialog">Compare Full Specs</button>
            </div>
        </div>
        <CompareDialog v-if="show" :source="source.dialog" @close="hideDialog"></CompareDialog>
    </div>
</template>

<script lang="ts" setup>
import { defineProps } from "vue";
import CompareDialog from "./CompareDialog.vue";

const props = defineProps<{ source: any }>();
const show = ref(false);
const showDialog = () => {
    show.value = true;
};

const hideDialog = () => {
    show.value = false;
};
</script>

<style lang="scss" scoped>
.leftbox {
    border-radius: 20px;
    border: 1.3px solid #fe2dea;
    box-shadow: 0px 0px 30px 4px #fe2dea21;
}

.rightbox {
    border-radius: 29px;
    border: 1px solid rgba(169, 169, 169, 1);
}
// .mask {
//     @apply h-44;
//     background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.95) 50%, rgba(255, 255, 255, 0.9) 60%, rgba(255, 255, 255, 0.88) 75%, rgba(255, 255, 255, 0) 100%);
// }
</style>
